import 'css/events.sass'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import marker_shadow from "leaflet/dist/images/marker-shadow.png"
import marker_icon from "leaflet/dist/images/marker-icon.png"
import marker_icon_retina from "leaflet/dist/images/marker-icon-2x.png"
import $ from 'jquery'
var i18n = window.i18n

import 'addthisbuttons.js'

// If there is a map on the page we must run Leaflet to display it.
$(function() {
  const map_div = $('#map')

  if (map_div.length > 0) {
    const latitude = map_div.attr('data-latitude')
    const longitude = map_div.attr('data-longitude')
    const zoom = map_div.attr('data-zoom')

    var map = L.map('map').setView([latitude, longitude], zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: i18n.gettext('&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors')
    }).addTo(map);

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: marker_icon_retina,
      iconUrl: marker_icon,
      shadowUrl: marker_shadow
    })

    L.marker([latitude, longitude]).addTo(map).openPopup();
  }
})
